import { Component, Input } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { Data } from '../expert-service-call.index'
import {
  DataLoaderService, ProgressBarService, PriceCalculationService,
  AlternateOptionsService, CommonDataService, SortingService
} from '../expert-service-call.index';
import { SummaryValidationComponent } from '../../normal-screen-components/summary-validations/summary-validations.component';
import * as _ from 'lodash';
@Component({
  selector: 'expert-mode-option-selection',
  templateUrl: './expert-mode-option-selection.template.html',
  styleUrls: ['./expert-mode-option-selection.css']
})
export class ExpertModeOptionSelection {
  public hideIfSmartVeh = false;
  public expertSuggestionList = [];
  public errMessage;

  // progress bar Variables
  public redProgressBar: boolean = false;
  public yellowProgressBar: boolean = false;
  public greenProgressBar: boolean = false;
  private subscription: Subscription;
  public saved: Data[] = [];
  public locSaved: Data[] = [];
  public pacSaved: Data[] = [];
  public locPacSaved: Data[] = [];
  private icon: string = "gray";
  public factoryOptions: Data[];
  public localOptions: Data[];
  public color: Data[];
  public upholstery: Data[];
  public rim: Data[];
  public trim: Data[];
  public addColorOptions: Data[];
  public standardOptions: Data[];
  public packageOptions: Data[];
  private localPackageOptions: Data[];
  private summeryFlag: boolean = false;


  constructor(private dataLoaderService: DataLoaderService,
    private commonDataService: CommonDataService, private progressService: ProgressBarService, private summaryValidationComponent: SummaryValidationComponent,
    private priceCalculationService: PriceCalculationService, private alternateOptionsService: AlternateOptionsService, private sortingService: SortingService) {
    this.factoryOptions = this.dataLoaderService.data.facOptions;
    this.localOptions = this.dataLoaderService.data.options;
    this.packageOptions = this.dataLoaderService.data.packages;
    this.color = this.dataLoaderService.data.color;
    this.upholstery = this.dataLoaderService.data.upholstery;
    this.rim = this.dataLoaderService.data.rim;
    this.trim = this.dataLoaderService.data.trim;
    this.standardOptions = this.dataLoaderService.data.stdOpt;
    this.addColorOptions = this.dataLoaderService.data.additionalColor;
    this.localPackageOptions = this.dataLoaderService.data.localPackagesList;

    if (this.dataLoaderService.data.additionalColor.length > 0)
      this.hideIfSmartVeh = true;
  }

  ngOnInit() {
    // this.cdr.detectChanges();
    this.progressService.illuminateRed();

    // To display the Progress services

    this.subscription = this.progressService.notifyObservableRed$.subscribe((res) => {
      this.redProgressBar = true;
      this.greenProgressBar = false;
      this.yellowProgressBar = false;
    });
    this.subscription = this.progressService.notifyObservableYellow$.subscribe((res) => {
      this.redProgressBar = false;
      this.greenProgressBar = false;
      this.yellowProgressBar = true;
    });
    this.subscription = this.progressService.notifyObservableGreen$.subscribe((res) => {
      this.redProgressBar = false;
      this.greenProgressBar = true;
      this.yellowProgressBar = false;
    });


  }
  removeDuplicate(item){
    item = _.uniqBy(item, function (o) {
      return o;
    });
    return item;
  }
  addedCodes(){
    // color
    for (let i in this.color) {
      if (this.color[i].selected 
        && this.color[i].code != this.dataLoaderService.previousColorExp) {
          this.dataLoaderService.expAdd.push(this.color[i].code);
      }
    }
    // Upholestry
    for (let i in this.upholstery) {
      if (this.upholstery[i].selected 
        && this.upholstery[i].code != this.dataLoaderService.previousUpholsteryExp) {
          this.dataLoaderService.expAdd.push(this.upholstery[i].code);
      }
    }
    // Additional Color
    for (let i in this.addColorOptions) {
      if (this.addColorOptions[i].selected 
        && this.addColorOptions[i].code != this.dataLoaderService.previousAddColorExp) {
          this.dataLoaderService.expAdd.push(this.addColorOptions[i].code);
      }
    }
    // Rim
    for (let i in this.rim) {
      if (this.rim[i].selected 
        && this.rim[i].code != this.dataLoaderService.previousRimExp) {
          this.dataLoaderService.expAdd.push(this.rim[i].code);
      }
    }
    // Trim
    for (let i in this.trim) {
      if (this.trim[i].selected 
        && this.trim[i].code != this.dataLoaderService.previousTrimExp) {
          this.dataLoaderService.expAdd.push(this.trim[i].code);
      }
    }
    // Factory options
    for (let i in this.factoryOptions) {
      if(this.factoryOptions[i].selected){
        if(this.dataLoaderService.previousFactoryExp.length <= 0){
          this.dataLoaderService.expAdd.push(this.factoryOptions[i].code);
          // this.removeDuplicates(this.dataLoaderService.expAdd)
        }
        else{
          for(let j=0; j<this.dataLoaderService.previousFactoryExp.length; j++){
            if (this.factoryOptions[i].code != this.dataLoaderService.previousFactoryExp[j]) {
                this.dataLoaderService.expAdd.push(this.factoryOptions[i].code);
            }
          }
          // this.removeDuplicates(this.dataLoaderService.expAdd)
        }
      }
    }
    this.dataLoaderService.expAdd = this.removeDuplicate(this.dataLoaderService.expAdd);
    // Remove added codes if its initially selected
    for (let i in this.factoryOptions) {
      for(let j=0; j<this.dataLoaderService.previousFactoryExp.length; j++){
        for(let k=0; k<this.dataLoaderService.expAdd.length; k++){
          if (this.factoryOptions[i].selected 
            && this.factoryOptions[i].code == this.dataLoaderService.previousFactoryExp[j]
            && this.dataLoaderService.previousFactoryExp[j]==this.dataLoaderService.expAdd[k]) {
              this.dataLoaderService.expAdd.splice(Number(k), 1);
          }
        }
      }
    }
    // Local options
    for (let i in this.localOptions) {
      if(this.localOptions[i].selected){
        if(this.dataLoaderService.previousLocalExp.length <= 0){
          this.dataLoaderService.expAdd.push(this.localOptions[i].code);
          // this.removeDuplicates(this.dataLoaderService.expAdd)
        }
        else{
          for(let j=0; j<this.dataLoaderService.previousLocalExp.length; j++){
            if (this.localOptions[i].code != this.dataLoaderService.previousLocalExp[j]) {
                this.dataLoaderService.expAdd.push(this.localOptions[i].code);
            }
          }
          // this.removeDuplicates(this.dataLoaderService.expAdd)
        }
      }
    }
    this.dataLoaderService.expAdd = this.removeDuplicate(this.dataLoaderService.expAdd);
    // Remove added codes if its initially selected
    for (let i in this.localOptions) {
      for(let j=0; j<this.dataLoaderService.previousLocalExp.length; j++){
        for(let k=0; k<this.dataLoaderService.expAdd.length; k++){
          if (this.localOptions[i].selected 
            && this.localOptions[i].code == this.dataLoaderService.previousLocalExp[j]
            && this.dataLoaderService.previousLocalExp[j]==this.dataLoaderService.expAdd[k]) {
              this.dataLoaderService.expAdd.splice(Number(k), 1);
          }
        }
      }
    }
    // Package options
    for (let i in this.packageOptions) {
      if(this.packageOptions[i].selected){
        if(this.dataLoaderService.previousPackagesExp.length <= 0){
          this.dataLoaderService.expAdd.push(this.packageOptions[i].code);
          // this.removeDuplicates(this.dataLoaderService.expAdd)
        }
        else{
          for(let j=0; j<this.dataLoaderService.previousPackagesExp.length; j++){
            if (this.packageOptions[i].code != this.dataLoaderService.previousPackagesExp[j]) {
                this.dataLoaderService.expAdd.push(this.packageOptions[i].code);
            }
          }
          // this.removeDuplicates(this.dataLoaderService.expAdd)
        }
      }
    }
    this.dataLoaderService.expAdd = this.removeDuplicate(this.dataLoaderService.expAdd);
    // Remove added codes if its initially selected
    for (let i in this.packageOptions) {
      for(let j=0; j<this.dataLoaderService.previousPackagesExp.length; j++){
        for(let k=0; k<this.dataLoaderService.expAdd.length; k++){
          if (this.packageOptions[i].selected 
            && this.packageOptions[i].code == this.dataLoaderService.previousPackagesExp[j]
            && this.dataLoaderService.previousPackagesExp[j]==this.dataLoaderService.expAdd[k]) {
              this.dataLoaderService.expAdd.splice(Number(k), 1);
          }
        }
      }
    }
    
    // Local Package options
    for (let i in this.localPackageOptions) {
      if(this.localPackageOptions[i].selected){
        if(this.dataLoaderService.previousLocalPackagesExp.length <= 0){
          this.dataLoaderService.expAdd.push(this.localPackageOptions[i].code);
          // this.removeDuplicates(this.dataLoaderService.expAdd)
        }
        else{
          for(let j=0; j<this.dataLoaderService.previousLocalPackagesExp.length; j++){
            if (this.localPackageOptions[i].code != this.dataLoaderService.previousLocalPackagesExp[j]) {
                this.dataLoaderService.expAdd.push(this.localPackageOptions[i].code);
            }
          }
          // this.removeDuplicates(this.dataLoaderService.expAdd)
        }
      }
    }
    this.dataLoaderService.expAdd = this.removeDuplicate(this.dataLoaderService.expAdd);
    // Remove added codes if its initially selected
    for (let i in this.localPackageOptions) {
      for(let j=0; j<this.dataLoaderService.previousLocalPackagesExp.length; j++){
        for(let k=0; k<this.dataLoaderService.expAdd.length; k++){
          if (this.localPackageOptions[i].selected 
            && this.localPackageOptions[i].code == this.dataLoaderService.previousLocalPackagesExp[j]
            && this.dataLoaderService.previousLocalPackagesExp[j]==this.dataLoaderService.expAdd[k]) {
              this.dataLoaderService.expAdd.splice(Number(k), 1);
          }
        }
      }
    }
    this.dataLoaderService.expAdd = _.uniqBy(this.dataLoaderService.expAdd, function (o) {
      return o;
    });
  }

  remvoedCodes(){
    // Additional Color
    for (let i in this.addColorOptions) {
      if (!this.addColorOptions[i].selected 
        && this.addColorOptions[i].code == this.dataLoaderService.previousAddColorExp) {
          this.dataLoaderService.expertRemovedCodes.push(this.addColorOptions[i]);
      }
    }
    // Rim
    for (let i in this.rim) {
      if (!this.rim[i].selected 
        && this.rim[i].code == this.dataLoaderService.previousRimExp) {
          this.dataLoaderService.expertRemovedCodes.push(this.rim[i]);
      }
    }
    // Trim
    for (let i in this.trim) {
      if (!this.trim[i].selected 
        && this.trim[i].code == this.dataLoaderService.previousTrimExp) {
          this.dataLoaderService.expertRemovedCodes.push(this.trim[i]);
      }
    }
    // Factory options
    for (let i in this.factoryOptions) {
      for(let j in this.dataLoaderService.previousFactoryExp){
        if (!this.factoryOptions[i].selected 
          && this.factoryOptions[i].code == this.dataLoaderService.previousFactoryExp[j]) {
            this.dataLoaderService.expertRemovedCodes.push(this.factoryOptions[i]);
        }
      }
    }
    // Local options
    for (let i in this.localOptions) {
      for(let j in this.dataLoaderService.previousLocalExp){
        if (!this.localOptions[i].selected 
          && this.localOptions[i].code == this.dataLoaderService.previousLocalExp[j]) {
            this.dataLoaderService.expertRemovedCodes.push(this.localOptions[i]);
        }
      }
    }
    // Package options
    for (let i in this.packageOptions) {
      for(let j in this.dataLoaderService.previousPackagesExp){
        if (!this.packageOptions[i].selected 
          && this.packageOptions[i].code == this.dataLoaderService.previousPackagesExp[j]) {
            this.dataLoaderService.expertRemovedCodes.push(this.packageOptions[i]);
        }
      }
    }
    // Local Package options
    for (let i in this.localPackageOptions) {
      for(let j in this.dataLoaderService.previousLocalPackagesExp){
        if (!this.localPackageOptions[i].selected 
          && this.localPackageOptions[i].code == this.dataLoaderService.previousLocalPackagesExp[j]) {
            this.dataLoaderService.expertRemovedCodes.push(this.localPackageOptions[i]);
        }
      }
    }
  }
  loadSuggestions() {
    // for added codes
    this.addedCodes();
    // for removed codes
    this.remvoedCodes();
    if (this.dataLoaderService.flagDictionary.migrationFlag) {
      this.summeryFlag = false;
    }
    if (this.dataLoaderService.vehicleInfo.urlFlag === '2') {
      this.summaryValidationComponent.alternateOptionsForURLFlag2Validate();
    }
    else {
      this.dataLoaderService.flagDictionary.alternateOverlayFlag = true;
      this.dataLoaderService.flagDictionary.loadingFlag = true;
      this.progressService.illuminateYellow();
      let returnAlternateValues = this.alternateOptionsService.getAlternateOptionsExpert();
      returnAlternateValues.subscribe(
        alternateResponse => {
          if (alternateResponse.suggestions[0].addedCodes.length > 0 || alternateResponse.suggestions[0].removedCodes.length > 0) {
            this.expertSuggestionList = alternateResponse.suggestions;
            this.commonDataService.sendSuggestion(this.expertSuggestionList);
            this.openAlternateScreen();
            this.dataLoaderService.flagDictionary.loadingFlag = false;
            this.dataLoaderService.flagDictionary.migrationFlag = true;
          }
          else {
            this.dataLoaderService.flagDictionary.alternateOverlayFlag = false;
            this.dataLoaderService.flagDictionary.expertSummaryFlag = true;
            this.progressService.progressBarValidation();

            //Color Updated Prices from validation response
              for (let k in this.color) {
                for (let s in this.dataLoaderService.gccUpdatedPrices) {
                    if ((this.color[k].code == this.dataLoaderService.gccUpdatedPrices[s].code) && (this.color[k].codeType == this.dataLoaderService.gccUpdatedPrices[s].codeType)) {
                      this.color[k].price = this.dataLoaderService.gccUpdatedPrices[s].price;
                    }
                  }
                // for undo
                if(this.color[k].selected){
                  this.dataLoaderService.previousColorExp=this.color[k].code;
                } 
              }

             //Additional Color Updated Prices from validation response
              for (let k in this.addColorOptions) {
                for (let s in this.dataLoaderService.gccUpdatedPrices) {
                  // for (let c in this.dataLoaderService.gccUpdatedPrices[s]) {
                    if ((this.addColorOptions[k].code == this.dataLoaderService.gccUpdatedPrices[s].code) && (this.addColorOptions[k].codeType == this.dataLoaderService.gccUpdatedPrices[s].codeType)) {
                      this.addColorOptions[k].price = this.dataLoaderService.gccUpdatedPrices[s].price;
                    }
                  }
                  // for undo
                if(this.addColorOptions[k].selected){
                  this.dataLoaderService.previousAddColorExp=this.addColorOptions[k].code;
                } 
              }

            //Upholstery Updated Prices from validation response
              for (let k in this.upholstery) {
                for (let s in this.dataLoaderService.gccUpdatedPrices) {
                  if ((this.upholstery[k].code == this.dataLoaderService.gccUpdatedPrices[s].code) && (this.upholstery[k].codeType == this.dataLoaderService.gccUpdatedPrices[s].codeType)) {
                    this.upholstery[k].price = this.dataLoaderService.gccUpdatedPrices[s].price;
                  }
                }
                if(this.upholstery[k].selected){
                  this.dataLoaderService.previousUpholsteryExp=this.upholstery[k].code;
                }
              }

            //Rim Updated Prices from validation response
              for (let k in this.rim) {
                for (let s in this.dataLoaderService.gccUpdatedPrices) {
                  if ((this.rim[k].code == this.dataLoaderService.gccUpdatedPrices[s].code) && (this.rim[k].codeType == this.dataLoaderService.gccUpdatedPrices[s].codeType)) {
                    this.rim[k].price = this.dataLoaderService.gccUpdatedPrices[s].price;
                  }
                }
                if(this.rim[k].selected){
                  this.dataLoaderService.previousRimExp=this.rim[k].code;
                }
              }

             //Trim Updated Prices from validation response
              for (let k in this.trim) {
                for (let s in this.dataLoaderService.gccUpdatedPrices) {
                    if ((this.trim[k].code == this.dataLoaderService.gccUpdatedPrices[s].code) && (this.trim[k].codeType == this.dataLoaderService.gccUpdatedPrices[s].codeType)) {
                      this.trim[k].price = this.dataLoaderService.gccUpdatedPrices[s].price;
                    }
                }
                if(this.trim[k].selected){
                  this.dataLoaderService.previousTrimExp=this.trim[k].code;
                }
              }


             //Factory options Updated Prices from validation response
              for (let k in this.factoryOptions) {
                for (let s in this.dataLoaderService.gccUpdatedPrices) {
                    if ((this.factoryOptions[k].code == this.dataLoaderService.gccUpdatedPrices[s].code) &&  (this.factoryOptions[k].codeType == this.dataLoaderService.gccUpdatedPrices[s].codeType)) {
                      this.factoryOptions[k].price = this.dataLoaderService.gccUpdatedPrices[s].price;
                    }
                }
                // for undo
                if(this.factoryOptions[k].selected){
                  this.dataLoaderService.previousFactoryExp.push(this.factoryOptions[k].code);
                }
              }

            //Local options
            //Updated prices from validation response
              for (let k in this.localOptions) {
                for (let s in this.dataLoaderService.gccUpdatedPrices) {
                    if ((this.localOptions[k].code == this.dataLoaderService.gccUpdatedPrices[s].code) && (this.localOptions[k].codeType == this.dataLoaderService.gccUpdatedPrices[s].codeType)) {
                      this.localOptions[k].price = this.dataLoaderService.gccUpdatedPrices[s].price;
                    }
                }
                // for undo
                if(this.localOptions[k].selected){
                  this.dataLoaderService.previousLocalExp.push(this.localOptions[k].code);
                }
              }

            //Package Options Updated Prices from validation response
              for (let k in this.packageOptions) {
                for (let s in this.dataLoaderService.gccUpdatedPrices) {
                  if ((this.packageOptions[k].code == this.dataLoaderService.gccUpdatedPrices[s].code) && (this.packageOptions[k].codeType == this.dataLoaderService.gccUpdatedPrices[s].codeType)) {
                    this.packageOptions[k].price = this.dataLoaderService.gccUpdatedPrices[s].price;
                  }
                }
                // for undo
                if(this.packageOptions[k].selected){
                  this.dataLoaderService.previousPackagesExp.push(this.packageOptions[k].code);
                }
              }

            //Local Package Options Updated Prices from validation response
              for (let k in this.localPackageOptions) {
                for (let s in this.dataLoaderService.gccUpdatedPrices) {
                  if ((this.localPackageOptions[k].code == this.dataLoaderService.gccUpdatedPrices[s].code) && (this.localPackageOptions[k].codeType == this.dataLoaderService.gccUpdatedPrices[s].codeType)) {
                    this.localPackageOptions[k].price = this.dataLoaderService.gccUpdatedPrices[s].price;
                  }
                }
                // for undo
                if(this.localPackageOptions[k].selected){
                  this.dataLoaderService.previousLocalPackagesExp.push(this.localPackageOptions[k].code);
                }
              }

            //standard Options Updated Prices from validation response
              for (let k in this.standardOptions) {
                for (let s in this.dataLoaderService.gccUpdatedPrices) {
                    if ((this.standardOptions[k].code == this.dataLoaderService.gccUpdatedPrices[s].code) && (this.standardOptions[k].codeType == this.dataLoaderService.gccUpdatedPrices[s].codeType)) {
                      this.standardOptions[k].price = this.dataLoaderService.gccUpdatedPrices[s].price;
                    }
                }
              }

            
            this.dataLoaderService.flagDictionary.loadingFlag = false;
            this.dataLoaderService.flagDictionary.migrationFlag = true;
            if (this.summeryFlag) {
              document.getElementById('expertSummary').style.display = 'block';
            }
            if (this.dataLoaderService.flagDictionary.testFlag) {
              this.dataLoaderService.flagDictionary.expertFlag = true;
            }
          }
        }, err => {
          if (err._body !== undefined) {
            this.errMessage = err._body;
            this.commonDataService.notifyErrorMsgItem(this.errMessage);
            this.openAlternateErrorScreen();
            this.dataLoaderService.flagDictionary.loadingFlag = false;
            this.dataLoaderService.flagDictionary.migrationFlag = false;
          }
        }
      );
    }

    this.sortingService.sortCodes(this.factoryOptions, true)
    this.sortingService.sortCodes(this.packageOptions, true)
    this.sortingService.sortCodes(this.localPackageOptions, true)
    this.sortingService.sortCodes(this.localOptions, true)
    this.sortingService.sortCodes(this.color, true)
    this.sortingService.sortCodes(this.upholstery, true)
    this.sortingService.sortCodes(this.rim, true)
    this.sortingService.sortCodes(this.trim, true)
   

  }

  /**
 * To switch back to NORMAL MODE from EXPERT MODE screen
 * @param none
 * @returns none
 */
  openNormalMode() {
    // this.dataLoaderService.flagDictionary.modeFlag = 'normal';
    //for pop up
    this.summeryFlag = false;
    this.dataLoaderService.flagDictionary.testFlag = false;
    if (this.dataLoaderService.vehicleInfo.urlFlag === '2') {
      if (this.dataLoaderService.flagDictionary.expertValidateFlag) {
        this.dataLoaderService.flagDictionary.openExpertValidateFlag = true;
        this.dataLoaderService.flagDictionary.confirmValidateFlag = true;
      }
      else if (!this.dataLoaderService.flagDictionary.validated) {
        this.dataLoaderService.flagDictionary.expertvalidated = false;
        this.dataLoaderService.flagDictionary.openExpertValidateFlag = true;
        this.dataLoaderService.flagDictionary.confirmValidateFlag = true;
      }
      else {
        this.dataLoaderService.flagDictionary.openExpertValidateFlag = false;
        //close expert modal
        this.dataLoaderService.flagDictionary.expertFlag = true;
      }

    }
    else {
      if (this.dataLoaderService.flagDictionary.expertValidateFlag) {
        this.dataLoaderService.flagDictionary.openExpertValidateFlag = true;
        this.dataLoaderService.flagDictionary.confirmValidateFlag = true;
        this.dataLoaderService.flagDictionary.testFlag = true;
      }
      else if (this.dataLoaderService.flagDictionary.expertvalidated) {
        this.dataLoaderService.flagDictionary.openExpertValidateFlag = true;
        this.dataLoaderService.flagDictionary.confirmValidateFlag = true;
        this.dataLoaderService.flagDictionary.testFlag = true;
      }
      else {
        this.dataLoaderService.flagDictionary.openExpertValidateFlag = false;
        //close expert modal
        this.dataLoaderService.flagDictionary.expertFlag = true;
      }
    }

    if (this.dataLoaderService.flagDictionary.migrationFlag) {
      this.dataLoaderService.flagDictionary.expertFlag = true;
      this.dataLoaderService.flagDictionary.openExpertValidateFlag = false;

    }
    this.commonDataService.notifyOther({ option: 'defaultOpen' });
  }

  openAlternateScreen() {
    this.dataLoaderService.flagDictionary.alternateValidateFlag = true;
    this.dataLoaderService.flagDictionary.alternateErrorFlag = false;
    this.progressService.illuminateRed();
  }
  openAlternateErrorScreen() {
    this.dataLoaderService.flagDictionary.alternateErrorFlag = true;
    this.dataLoaderService.flagDictionary.alternateValidateFlag = false;
    this.progressService.illuminateYellow();
  }
  openSummary() {
    this.summeryFlag = true;
    this.dataLoaderService.flagDictionary.testFlag = false;
    if (this.dataLoaderService.vehicleInfo.urlFlag === '2') {
      if (!this.dataLoaderService.flagDictionary.expertvalidated) {
        this.dataLoaderService.flagDictionary.summaryValidate = true;
        this.dataLoaderService.flagDictionary.migrationFlag = false;
        this.loadSuggestions();
        this.dataLoaderService.flagDictionary.expertvalidated = true;
        if(this.dataLoaderService.flagDictionary.noAlternateInExpertMode){
          this.dataLoaderService.flagDictionary.expertSummaryFlag = true;
          setTimeout(() => {
            document.getElementById('expertSummary').style.display = 'block';
          }, 0);          
          this.dataLoaderService.flagDictionary.noAlternateInExpertMode = false;
        }
        
      }
      else {
        this.dataLoaderService.flagDictionary.expertSummaryFlag = true;
      }

    }
    else {
      this.dataLoaderService.flagDictionary.normalSummaryValidFlag = false;
      if (this.dataLoaderService.flagDictionary.expertValidateFlag) {
        this.dataLoaderService.flagDictionary.summaryValidate = true;
        this.dataLoaderService.flagDictionary.migrationFlag = false;
        this.loadSuggestions();
      }
      else {
        this.dataLoaderService.flagDictionary.expertSummaryFlag = true;
      }

      if (this.dataLoaderService.flagDictionary.migrationFlag || this.dataLoaderService.flagDictionary.expertValidateFlag || !this.dataLoaderService.flagDictionary.expertvalidated) {
        this.dataLoaderService.flagDictionary.expertSummaryFlag = true;
        this.summeryFlag = true;
      }
    }
  }
  openReset() {
    this.dataLoaderService.flagDictionary.expertResetFlag = false;
  }
  openCancel() {
    this.dataLoaderService.flagDictionary.expertCancelFlag = true;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/selectable-tabs/expert-screen-components/expert-mode-options/expert-mode-option-selection.ts